// extracted by mini-css-extract-plugin
export default {"title":"pefCntQ1xAmtXaRb2ULV","buttons":"mtK60PHm71msHZPxxwEk"};